<template>
  <infoBlock :title="$t('students.login_data')" marker-color="#F27C4A" class="profile-login-data">
    <div v-if="user.getLogin()" class="profile-block__row">
      <div class="profile-block__row-label">{{ $t('labels.login') }}</div>
        <div class="profile-block__row-data">{{ user.getLogin() }}</div>
      </div>
      <div v-if="user.getEmail()" class="profile-block__row">
        <div class="profile-block__row-label">{{ $t('labels.email') }}</div>
        <div class="profile-block__row-data">{{ user.getEmail() }}</div>
      </div>
      <div v-if="user.getPhone()" class="profile-block__row">
        <div class="profile-block__row-label">{{ $t('labels.phone') }}</div>
      <div class="profile-block__row-data">{{ user.getMaskedPhone() }}</div>
    </div>
  </infoBlock>
</template>
<script>
  import infoBlock from 'src/components/InfoBlock/InfoBlock.vue'
  export default {
    props: ['user'],
    components: {
      infoBlock
    }
  }
</script>
<style lang="scss">
.profile-login-data {
  &:before {
    background: #F27C4A;
  }
}
</style>